module.exports = __webpack_public_path__ + "img/page15_text.cf7c6841.png";